import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/pecuaria/cadastro/especie' };
/////////////////////////////////////////////////////////////////////////////////

export function createAnimalEspecieCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateAnimalEspecieCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listAnimalEspecieCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findAnimalEspecieCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function deleteAnimalEspecieCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

